// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"xz-z","smallCardRow":"yz-z","largeCardRow":"zz-z","productSearchRow":"Az-z","curatedRow":"Bz-z"};